package com.kinoshazam.screens.login.expanded

import androidx.compose.runtime.Composable
import com.kinoshazam.screens.login.compact.CompactLoginContent
import presentation.screens.login.LoginMVIAction
import presentation.screens.login.LoginState

@Composable
actual fun ExpandedLoginContent(
    state: LoginState,
    onAction: (LoginMVIAction) -> Unit,
) {
    CompactLoginContent(
        state = state,
        onAction = onAction,
    )
}
